import '@fancyapps/fancybox';

/**
 * on dom ready
 */
(function () {

    var initFancybox = function ($) {
            var fancyboxDefaults = {
                infobar : true,
                toolbar  : true,
                arrows: true,
                keyboard: true,
                buttons : [
                    //"zoom",
                    //"share",
                    "slideShow",
                    //"fullScreen",
                    //"download",
                    "thumbs",
                    "close"
                ],
                baseTpl:
                    '<div class="fancybox-container" role="dialog" tabindex="-1">' +
                    '<div class="fancybox-bg"></div>' +
                    '<div class="fancybox-inner">' +
                    '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
                    '<div class="fancybox-toolbar">{{buttons}}</div>' +
                    '<div class="fancybox-navigation">{{arrows}}</div>' +
                    '<div class="fancybox-stage"></div>' +
                    '</div>' +
                    '</div>',
                afterLoad: function (fb, item) {
                    var caption = $(item.$thumb).closest('[data-fancybox]').data('caption');
                    item.$content.remove('.fancybox-custom-caption').append('<div class="fancybox-custom-caption">' + (caption ? caption : '') + '</div>');
                },
                btnTpl: {
                    arrowLeft:
                        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
                        '<div class="fancybox-custom-button u-icon u-icon-before--chevron-left"></div>' +
                        "</button>",
                    arrowRight:
                        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
                        '<div class="fancybox-custom-button u-icon u-icon-before--chevron-right"></div>' +
                        "</button>"
                }
            };
            $('[data-fancybox]').fancybox(fancyboxDefaults);

            // Cookie callout
            if (getCookie('cookie-advice-removed') == null) {
                $('.c-callout').removeClass('c-callout--closed');
            }


            $('[data-cookiehint-close]').click(function () {
                setCookie('cookie-advice-removed', 1, 7);
            });


            /**
             * Set cookie helper function
             * @param name
             * @param value
             * @param days
             */
            function setCookie(name, value, days) {
                var d = new Date;
                d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
                document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
            }


            /**
             *
             * @param name
             * @returns cookieValue|null
             */
            function getCookie(name) {
                var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
                return v ? v[2] : null;
            }
        },
        deferred = function () {
            if (window.jQuery) {
                initFancybox(jQuery);
            } else {
                setTimeout(deferred, 50);
            }
        };
    deferred();
}());
